import React from 'react';
import { Button } from '../ui/button';
import { BookmarkSimple, X, Scales, MapPin, Ruler, Trash } from '@phosphor-icons/react';

export const SavedEstimatesSidebar = ({ isOpen, onClose, savedEstimates, onLoad, onDelete, onCompare, selectedForCompare }) => {
  if (!isOpen) return null;
  
  return (
    <div className="fixed inset-0 z-50 flex justify-end">
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />
      <div className="relative w-full max-w-md bg-white dark:bg-[#0F172A] border-l-2 border-black dark:border-white h-full overflow-y-auto">
        <div className="sticky top-0 p-4 border-b-2 border-black dark:border-white bg-[#2B4C6F] text-white flex items-center justify-between z-10">
          <div className="flex items-center gap-2">
            <BookmarkSimple size={20} weight="fill" />
            <h3 className="font-black uppercase tracking-wide">Saved Estimates</h3>
          </div>
          <button onClick={onClose} className="hover:bg-white/20 p-1 rounded"><X size={20} /></button>
        </div>
        
        {savedEstimates.length === 0 ? (
          <div className="p-8 text-center">
            <BookmarkSimple size={48} weight="light" className="text-neutral-300 mx-auto mb-4" />
            <p className="text-neutral-500">No saved estimates yet</p>
          </div>
        ) : (
          <div className="p-4 space-y-3">
            {selectedForCompare.length > 0 && (
              <Button
                onClick={onCompare}
                disabled={selectedForCompare.length < 2}
                className="w-full h-12 bg-amber-500 hover:bg-amber-600 text-white font-bold uppercase tracking-wide border-2 border-black rounded-none shadow-[4px_4px_0px_#000]"
              >
                <Scales size={18} className="mr-2" />
                Compare ({selectedForCompare.length}) Selected
              </Button>
            )}
            
            {savedEstimates.map((est) => (
              <div 
                key={est.id} 
                className={`border-2 ${selectedForCompare.includes(est.id) ? 'border-amber-500 bg-amber-50 dark:bg-amber-900/20' : 'border-black dark:border-white'} p-4`}
              >
                <div className="flex items-start justify-between mb-2">
                  <div>
                    <h4 className="font-bold text-neutral-900 dark:text-white">{est.name}</h4>
                    <p className="text-xs text-neutral-500 uppercase">{est.job_type?.replace('_', ' ')}</p>
                  </div>
                  <label className="flex items-center gap-2 cursor-pointer">
                    <input
                      type="checkbox"
                      checked={selectedForCompare.includes(est.id)}
                      onChange={(e) => {
                        if (e.target.checked && selectedForCompare.length < 4) {
                          onCompare([...selectedForCompare, est.id]);
                        } else {
                          onCompare(selectedForCompare.filter(id => id !== est.id));
                        }
                      }}
                      className="w-4 h-4 accent-amber-500"
                    />
                    <span className="text-xs text-neutral-500">Compare</span>
                  </label>
                </div>
                
                <p className="text-lg font-mono font-bold text-[#2B4C6F] mb-2">
                  ${est.price_low?.toLocaleString()} - ${est.price_high?.toLocaleString()}
                </p>
                
                <div className="flex items-center gap-2 text-xs text-neutral-500 mb-3">
                  <MapPin size={12} /> {est.location || 'No location'}
                  {est.square_footage && <><span>•</span><Ruler size={12} /> {est.square_footage} sq ft</>}
                </div>
                
                <div className="flex gap-2">
                  <Button
                    onClick={() => onLoad(est)}
                    size="sm"
                    variant="outline"
                    className="flex-1 h-8 text-xs font-bold border-2 border-black rounded-none"
                  >
                    View
                  </Button>
                  <Button
                    onClick={() => onDelete(est.id)}
                    size="sm"
                    variant="ghost"
                    className="h-8 px-2 text-red-500 hover:bg-red-50"
                  >
                    <Trash size={16} />
                  </Button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
